// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

const areaButtonEelements = document.querySelectorAll('[name="area"]');
if (areaButtonEelements.length) {
  areaButtonEelements.forEach((element) => {
    element.addEventListener('click', (event) => {
      if (document.getElementById('area_modal').children.length > 0) {
        document.getElementById('area_modal').children[0].remove();
      }

      $.ajax({
        url: `/areas/${event.target.dataset.areaId}/detail`,
        beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        type: 'GET',
        timeout: 3000,
      });
    });
  });
}

// show area

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.u-simpleToggleButton');
  const displayArea = document.getElementById('area-event-contents-display');

  const showEventContent = (eventType) => {
    const templateContent = document.getElementById(`${eventType}Events`).content;
    displayArea.innerHTML = ''; // コンテンツエリアをクリア
    displayArea.appendChild(templateContent.cloneNode(true)); // テンプレートの内容をコピーして追加
  };

  const toggleActiveClass = (button) => {
    buttons.forEach((btn) => btn.classList.remove('u-simpleToggleButton--active'));
    button.classList.add('u-simpleToggleButton--active');
  };

  const setupButtonClickEvents = () => {
    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const eventType = this.getAttribute('data-event');
        showEventContent(eventType);
        toggleActiveClass(this);
      });
    });
  };

  const setupInitialDisplay = () => {
    if (buttons.length > 0) {
      const initialButton = buttons[0];
      const initialEventType = initialButton.getAttribute('data-event');
      showEventContent(initialEventType);
      toggleActiveClass(initialButton);
    }
  };

  setupButtonClickEvents();
  setupInitialDisplay();

  // supplement swiper

  new Swiper(
    '.showArea__supplementSwiper',
    swiperOptions({
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true,
      navigation: {
        nextEl: '.showArea__supplementSwiper .u-articleSwiperButton--next',
        prevEl: '.showArea__supplementSwiper .u-articleSwiperButton--prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
      pagination: {
        el: '.showArea__supplementSwiperPagination',
        bulletClass: 'showArea__supplementSwiperPaginationBullet',
        bulletActiveClass: 'showArea__supplementSwiperPaginationBullet--active',
        clickable: true,
      },
    })
  );

  new Swiper(
    '.showArea__supplementSpotSwiper',
    swiperOptions({
      spaceBetween: 20,
      slidesPerView: 'auto',
      breakpoints: {
        768: {
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: '.showArticle__connectionSpotSwiperButtonNext--gourmet',
        prevEl: '.showArticle__connectionSpotSwiperButtonPrev--gourmet',
      },
    })
  );

  const areaButtons = document.querySelectorAll('.showArea__featuresAreaButton');
  const areaModal = document.getElementById('area_modal');
  if(areaButtons.length) {
    areaButtons.forEach((button) => {
      button.addEventListener('click', () => {
        areaModal.classList.toggle('active');
      });
    });
  }

  if(areaModal) {
    areaModal.addEventListener('click', (e) => {
      if (e.target.classList[0] === 'areaModal') {
        areaModal.classList.toggle('active');
      }
    });
  }

  if(areaModal) {
    const callback = () => {
      const areaModalCloseButton = document.querySelector('.areaModal__closeButton');
      if (areaModalCloseButton) {
        areaModalCloseButton.addEventListener('click', () => {
          areaModal.classList.remove('active');
        });
      }
    };
  
    const observer = new MutationObserver(callback);
  
    const config = {
      attributes: true, // 属性の変更を監視
      childList: true, // 子要素の追加または削除を監視
      subtree: true, // 子孫要素も監視対象に含む
    };
  
    observer.observe(areaModal, config);
  }

});
